import { PositionType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { ScatteringBeesAnimation } from '../../animations/ScatteringBeesAnimation';
import { getMatch2AssetPath } from '../../util/assets';

// types
//-----------------------------------------------------------------------------
export type BeeScatteringEffectOptions = {
  position: PositionType;
  asset?: string;
};

/*
    Bee scatering effect
*/
export class BeeScatteringEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _position: PositionType;
  private readonly _asset: string;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: BeeScatteringEffectOptions) {
    this._scene = scene;
    this._position = options.position;
    this._asset =
      options.asset ?? getMatch2AssetPath('fx.hive/fx.hive.bee.png');
  }

  public static assets(): string[] {
    return [];
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    this._animate();
  }

  // private: animation
  //-------------------------------------------------------------------------
  private async _animate() {
    // create animation
    const animation = new ScatteringBeesAnimation({ asset: this._asset });

    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this._scene,
      this._position,
      {},
      () => animation,
    );

    // run animations
    await animation.start();

    // despawn entity
    despawnOverlayEntity(this._scene, entity);
  }
}
